export default __webpack_public_path__ + "static/media/circleX.c1951b2b.svg";